import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantSelectTeamPage } from './merchant-select-team';

@NgModule({
  declarations: [
    MerchantSelectTeamPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantSelectTeamPage),
    TranslateModule.forChild()
  ],
})
export class MerchantSelectTeamPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-select-team/merchant-select-team.module.ts